const DEFAULT_API_BASE_URL = 'http://localhost:5000';
const DEFAULT_SENTIMENT_API_HOST = 'https://api-staging.sentiment.accessacloud.com';
const DEFAULT_MFE_REGISTRY_BASE = 'https://mfe.test.workspace.accessacloud.com/registry';
const DEFAULT_SENTIMENT_ACCOUNT_TOKEN = '';
const DEFAULT_SENTIMENT_REDISPLAY_DAYS = 0;

export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? DEFAULT_API_BASE_URL,
  graphqlBaseUrl: '',
  sentimentApiHost: import.meta.env.VITE_SENTIMENT_API_HOST ?? DEFAULT_SENTIMENT_API_HOST,
  mfeRegistryBase: import.meta.env.VITE_MFE_REGISTRY_BASE ?? DEFAULT_MFE_REGISTRY_BASE,
  sentimentAccountToken: import.meta.env.VITE_SENTIMENT_ACCOUNT_TOKEN ?? DEFAULT_SENTIMENT_ACCOUNT_TOKEN,
  sentimentRedisplayDays: Number(import.meta.env.VITE_SENTIMENT_REDISPLAY_DAYS ?? DEFAULT_SENTIMENT_REDISPLAY_DAYS),
};

export function setApiBaseUrl(url: string): void {
  API_CONFIG.baseUrl = url;
}

export function setGraphqlBaseUrl(url: string): void {
  API_CONFIG.graphqlBaseUrl = url;
}
